import { Component, ElementRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';

import { DxLoadPanelComponent, DxTemplateHost, NestedOptionHost, WatcherHelper } from 'devextreme-angular';

@Component({
  selector: 'abc-load-panel',
  template: '',
  standalone: true,
  providers: [DxTemplateHost, WatcherHelper, NestedOptionHost],
})
export class AbcLoadPanelComponent extends DxLoadPanelComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, optionHost, transferState, platformId);
  }
}
